import { Button } from '@avanta/shared/components/ui/Button';
import { LOCIZE_NS } from '@avanta/shared/constants/common';
import { cn } from '@avanta/shared/utils/cn';
import { ChevronRight } from 'lucide-react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { type OptionDTO } from 'types/surveys';

export const VerticalOptions = ({
  options,
  onSaveResponse,
}: {
  options: OptionDTO[];
  onSaveResponse: (option: OptionDTO) => void;
}): React.ReactElement => {
  const [selectedOption, setSelectedOption] = useState<OptionDTO | null>(null);
  const { t } = useTranslation(LOCIZE_NS.HOME);

  const handleOnSaveResponse = (): void => {
    if (selectedOption) {
      onSaveResponse(selectedOption);
    }
  };

  return (
    <div
      className={cn(
        'flex flex-col items-end am-lg:gap-18 gap-8 mt-4 am-lg:mt-6',
        !selectedOption && 'am-lg:mb-6 mb-0'
      )}
    >
      <div className="w-full flex flex-col relative self-start">
        <div className="flex flex-col gap-3 max-w-180">
          {options.map(option => (
            <div key={option.id} className="flex w-full">
              <input
                type="radio"
                id={option.id}
                name="survey-vertical-option"
                value={option.id}
                className="sr-only peer"
                checked={selectedOption?.id === option.id}
                onChange={() => setSelectedOption(option)}
              />
              <label
                htmlFor={option.id}
                className={cn(
                  'w-full bg-white text-sm leading-5 p-2.5 border border-teal-300 rounded-xl shadow-sm text-denim-500',
                  'hover:bg-plum-100 hover:border-transparent',
                  'peer-checked:bg-mint-100 peer-checked:border-teal-500',
                  'hover:peer-checked:bg-mint-100 hover:peer-checked:border-teal-500'
                )}
              >
                {option.emoji && <span>{option.emoji}</span>}
                <span className="text-sm text-center">{option.text}</span>
              </label>
            </div>
          ))}
        </div>
      </div>
      {selectedOption && (
        <Button
          variant="primary"
          size="lg"
          icon="trailing"
          className="am-lg:w-fit"
          onClick={handleOnSaveResponse}
        >
          {t('Common.next', { ns: LOCIZE_NS.COMMON })}
          <ChevronRight className="size-6" />
        </Button>
      )}
    </div>
  );
};
